import { createActionGroup, props } from '@ngrx/store';
import { Catalog, PaginatedResult, ProspectExtraFieldTemplateEntry } from '@niko-crm/ui';

export const CatalogActions = createActionGroup({
  source: 'Catalogs',
  events: {
    'Load Catalogs': props<{ catalogType: string; page: number; limit: number; parentId?: string }>(),
    'Load Catalogs Success': props<{ result: PaginatedResult<Catalog> }>(),
    'Load Catalogs Failure': props<{ error: string }>(),
    'Create Catalog': props<{ catalogType: string; payload: Partial<Catalog>; parentId?: string }>(),
    'Create Catalog Success': props<{ catalog: Catalog }>(),
    'Create Catalog Failure': props<{ error: string }>(),
    'Update Catalog': props<{ catalogType: string; id: string; payload: Partial<Catalog> }>(),
    'Update Catalog Success': props<{ catalog: Catalog }>(),
    'Update Catalog Failure': props<{ error: string }>(),
    'Delete Catalog': props<{ catalogType: string; id: string }>(),
    'Delete Catalog Success': props<{ id: string }>(),
    'Delete Catalog Failure': props<{ error: string }>(),
    'Load Prospect Extra Fields Template': props<Record<string, never>>(),
    'Load Prospect Extra Fields Template Success': props<{ fields: ProspectExtraFieldTemplateEntry[] }>(),
    'Load Prospect Extra Fields Template Failure': props<{ error: string }>(),
    // Pushes the response of a successful template PATCH so consumers react without a reload.
    'Set Prospect Extra Fields Template': props<{ fields: ProspectExtraFieldTemplateEntry[] }>(),
    'Clear Catalogs': props<Record<string, never>>(),
  },
});
